import React from 'react'

import Button, { ButtonProps } from '../Button'
import { ButtonVariant } from '../types'

const PrimaryButton = (props: ButtonProps) => <Button {...props} variant={ButtonVariant.Primary} />

export default PrimaryButton
